// removed by extract-text-webpack-plugin
module.exports = {"container":"_12jHn","center":"_2Xy4L","left":"_29KW1","hasCover":"hv6Wy","cover":"_2ttRg","contentWrapper":"_2SN6b","content":"_1oZiG","title":"_1Bn1k","statistics":"g946p","description":"y-5Kl","button":"_29-hJ","actions":"_2Geh5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/category-list-item-masonry/category-list-item-masonry.scss
// module id = 1471
// module chunks = 0